import dayjs from 'dayjs'
import React from 'react'
import { TestIds } from '../../../testIds'
import { colors } from '../../../themes/colors'
import { formatAgreementDates } from '../utils/formatAgreementDates'
import StatusChip from '../../../components/StatusChip'
import { StatusHeader } from '../../../components/StatusHeader'
import Typography from '../../../components/Typography'
import { Box, SxProps, Theme, styled } from '@mui/material'

interface Props {
  title: string
  category?: string
  status: string //'active' | 'expired' | 'cancelled'
  startDate: Date
  endDate: Date
  children?: React.ReactNode

  sxContainer?: SxProps<Theme>
}

const statusMap = {
  effective: {
    display: 'Active',
    textColor: colors.shade0,
    bgColor: colors.secondary700,
  },
  closed: {
    display: 'Closed',
    textColor: colors.shade0,
    bgColor: colors.grey800,
  },
  'on hold': {
    display: 'On hold',
    textColor: colors.shade100,
    bgColor: colors.grey300,
  },
  upcoming: {
    display: 'Upcoming',
    textColor: colors.shade100,
    bgColor: colors.primary300,
  },
}

const Container = styled(Box)`
  display: flex;
  flex-direction: row;
`
type Setting = (typeof statusMap)['effective']

export const AgreementTitle = ({ title, category, status, ...props }: Props) => {
  const isFuture = dayjs(props.startDate).isAfter(Date.now())

  const setting: Setting = isFuture
    ? statusMap['upcoming']
    : statusMap[status.toLowerCase() as keyof typeof statusMap] ?? {
        display: 'TBD',
        textColor: colors.shade0,
        bgColor: colors.secondary700,
      }

  return (
    <Container sx={props.sxContainer}>
      <StatusHeader
        statusChip={
          <StatusChip
            label={setting.display}
            variant='filled'
            bgColor={setting.bgColor}
            textColor={setting.textColor}
            data-testid={TestIds.components.statusHeader.statusBadge}
          />
        }
        title={title}
        subTitle={category}
        text={
          <Typography variant='body2' color='grey800'>
            Agreement dates - {formatAgreementDates(props.startDate, props.endDate)}
          </Typography>
        }
      />
      {props.children}
    </Container>
  )
}
